import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CvpProfileTimesheetInfo {
  candidateId: number;
  mostRecentTimesheetDate: string | null;
}

export interface ProfileTimesheetsInConcernResponse extends BackendResponse {
  items: CvpProfileTimesheetInfo[];
}

export interface ProfileTimesheetsInConcernParameters extends NextApiParams {
  k: number;
}

export const profileTimesheetsInConcern = withNextApi<
  ProfileTimesheetsInConcernResponse,
  ProfileTimesheetsInConcernParameters
>("/auth/ProfileTimesheetsInConcern", { method: "GET" });
